import { render, staticRenderFns } from "./uploadUserHead.vue?vue&type=template&id=10b48c65&scoped=true&"
import script from "./uploadUserHead.vue?vue&type=script&lang=js&"
export * from "./uploadUserHead.vue?vue&type=script&lang=js&"
import style0 from "./uploadUserHead.vue?vue&type=style&index=0&id=10b48c65&scoped=true&lang=css&"
import style1 from "./uploadUserHead.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b48c65",
  null
  
)

export default component.exports